export const isValidPercentage = (value: string): boolean => {
  const percentage = parseInt(value)
  if (isNaN(percentage)) return false
  if (percentage < 1 || percentage > 100) return false
  return true
}

export const validEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
